export default __webpack_public_path__ + "static/media/shrutiF.772c64bc.wav";